export default class FreelancerUserIgnoredSurveyData {
  constructor(item) {
    this.FreelancerUserId = item.FreelancerUserId;
    this.FreelancerUserName = `${item.FirstName} ${item.LastName}`;
    this.FreelancerUserIsRM = item.IsRM;
    this.FreelancerUserIsDQ = item.IsDQ;
    this.FeeType = null;
    this.ClientId = null;
    this.SurveyId = null;
    this.TpSurveyId = null;
  }
}
